import React from 'react';
import Markdown from '../components/Markdown';
import { PrivacyMarkdown } from './PrivacyMarkdown';
const Privacy = () => {
  return <Markdown md={PrivacyMarkdown} />;
};

export default Privacy;
